import React, { useState } from 'react';
import { Card, Input, Button, Result, Spin, Typography, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import axios from 'axios';
import ExpressTrackingTimeline from './orders/ExpressTrackingTimeline';
import './OrderTracking.css';

const OrderTracking = () => {
  const [searchText, setSearchText] = useState('');
  const [orderStatus, setOrderStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async () => {
    if (!searchText.trim()) {
      return;
    }

    setLoading(true);
    setError(null);
    setOrderStatus(null);

    try {
      const response = await axios.get(`/api/orders/search/?search=${searchText}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.data.length > 0) {
        const order = response.data[0];
        console.log('Order status:', order);
        setOrderStatus(order);
      } else {
        setError('未找到订单');
      }
    } catch (error) {
      console.error('Error searching order:', error);
      setError('搜索订单时出错');
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'SHIPPING':
        return '#1890ff';
      case 'ARRIVED':
        return '#52c41a';
      case 'INSPECTION_NEEDED':
        return '#faad14';
      case 'INSPECTED':
        return '#722ed1';
      case 'DELIVERING':
        return '#13c2c2';
      case 'DELIVERED':
        return '#52c41a';
      case 'RELEASED':
        return '#52c41a';
      case 'PENDING_REVIEW':
        return '#faad14';
      case 'PENDING_CUSTOMS':
        return '#faad14';
      case 'PICKED_UP':
        return '#1890ff';
      case 'INSPECTED_PENDING':
        return '#722ed1';
      default:
        return '#000000';
    }
  };

  const getStatusText = (status) => {
    const statusMap = {
      'CREATED': '已创建',
      'PRINTED': '已打印',
      'DUPLICATE': '重复订单',
      'SHIPPING': '运输中',
      'PENDING_REVIEW': '未审单',
      'PENDING_CUSTOMS': '待清关',
      'PICKED_UP': '已提货未过机',
      'INSPECTED_PENDING': '已出查验未放行',
      'RELEASED': '已放行',
      'DELIVERING': '派送中',
      'DELIVERED': '已送达',
    };
    return statusMap[status] || status;
  };

  return (
    <div className="order-tracking-container">
      <Card className="tracking-card">
        <div className="quick-link-section">
          <Typography.Text>
            快捷查询地址：
            <Typography.Text copyable={{ 
              text: 'https://sinobridge-sc.com/order-track/',
              onCopy: () => message.success('链接已复制到剪贴板')
            }}>
              https://sinobridge-sc.com/order-track/
            </Typography.Text>
          </Typography.Text>
        </div>

        <div className="search-section">
          <Input
            placeholder="请输入订单号或快递单号"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onPressEnter={handleSearch}
            prefix={<SearchOutlined />}
            className="tracking-input"
          />
          <Button type="primary" onClick={handleSearch}>
            查询
          </Button>
        </div>

        <div className="result-section">
          {loading ? (
            <div className="loading-container">
              <Spin size="large" />
            </div>
          ) : error ? (
            <Result
              status="warning"
              title={error}
            />
          ) : orderStatus ? (
            <div className="status-container">
              <div className="status-header">
                <h2>订单状态</h2>
                <h2>运输轨迹</h2>
              </div>
              <div className="status-content">
                <div className="status-info">
                  <div className="status-item">
                    <span className="label">订单号:</span>
                    <span className="value">{orderStatus.order_number}</span>
                  </div>
                  <div className="status-item">
                    <span className="label">状态:</span>
                    <span 
                      className="value status-value"
                      style={{ color: getStatusColor(orderStatus.status) }}
                    >
                      {getStatusText(orderStatus.status)}
                    </span>
                  </div>
                  {orderStatus.express_number && (
                    <div className="status-item">
                      <span className="label">快递单号:</span>
                      <span className="value">{orderStatus.express_number}</span>
                    </div>
                  )}
                  <div className="status-item">
                    <span className="label">收件人:</span>
                    <span className="value">{orderStatus.recipient_name}</span>
                  </div>
                  <div className="status-item">
                    <span className="label">地址:</span>
                    <span className="value">
                      {`${orderStatus.recipient_province}${orderStatus.recipient_city}${orderStatus.recipient_district}${orderStatus.recipient_address}`}
                    </span>
                  </div>
                </div>
                
                {/* Tracking Timeline */}
                <div className="timeline-container">
                  {orderStatus.express_number && (
                    <ExpressTrackingTimeline
                      expressNumber={orderStatus.express_number}
                      recipientPhone={orderStatus.recipient_phone?.slice(-4)}
                      onTrackingUpdate={(updatedData) => {
                        if (updatedData?.status) {
                          setOrderStatus(prev => ({
                            ...prev,
                            status: updatedData.status
                          }));
                        }
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </Card>
    </div>
  );
};

export default OrderTracking;
